<template>
	<div class="noscroll fplus-step-details">
    <!--  Scroll if not in step settings -->
    <div class="main-content " :class="{'scroll':show}">
      <Loading v-if="loading"/>

	    <div v-else class="pages-list">
		    <div class="__actions-btns">
			    <v-button @click="stepSettingsOpen=true"
			              v-tippy="{theme:'small-black'}" content="Step settings" class="small-btn step-settings-btn"
			              :locked="!is('editor')"
			              flat :icon="require('@/assets/img/settings_btn.svg')" />
			    <span class="__sep"/>
			    <quick-actions-btn v-if="hasSplitTests" @itemClick="deleteStepOpen=true" :items="[{label:'Delete step',icon:require('@/assets/img/trash.svg')}]" />

			    <template v-else>
				    <quick-actions-btn @itemClick="stepMenuClick" :items="[
								{label:'Revisions...',icon:require('@/assets/img/history.svg')},
								'',
								{label:'Delete step',icon:require('@/assets/img/trash.svg')}]" />
				    <popup-backdrop v-if="revisionsPopupOpen" @close="revisionsPopupOpen=false">
					    <page-revisions-popup :page="stepData.pages[0]" :step="step"
					                          @done="revisionsPopupOpen=false" @close="revisionsPopupOpen=false" />
				    </popup-backdrop>
			    </template>
		    </div>

        <div class="funnel_steps_top first-page" v-if="stepData" :class="{'has-split-test':hasSplitTests}">

            <div class="left_img_wrpr" style="position: relative;">
                <img :src="stepData.thumbnail_hash" alt=""
                     @load="imageLoading=false">
              <loading v-if="imageLoading && !loading"></loading>
            </div>

            <div class="right">
                <div class="funnel_tag_wrpr">
                    <div class="funnel_tag" v-if="resultItems.length && resultItems[stepData.type -1]">
                        <span class="icon">
                            <inline-svg :src="(stepData.type && resultItems[stepData.type -1]) ? resultItems[stepData.type -1].img : ''"/>
                        </span>
                        {{ stepData.type ? resultItems[stepData.type -1].title : ''}}
                    </div>
                </div>
                <h3>{{ stepData.name }}</h3>
                <div class="funnel_steps_urls_wrpr" v-if="stepData.url">
                    <div class="funnel_steps_url_item">
                        <span class="item_title">Step URL</span>
                        <div class="links-items-group">
                            <a :href="'https://'+stepData.url" target="_blank" class="link_item">{{stepData.url }}</a>
                            <input type="hidden" id="step_url_hidden" :value="'https://'+stepData.url">
                            <div class="icon icon-circle pointer" @click="copyToClipboard('#step_url_hidden')">
                                <inline-svg :src="require('@/assets/img/copy_icon_sm.svg')"/>
                            </div>
                            <a :href="'https://'+stepData.url" target="_blank" class="icon icon-circle pointer">
                                <inline-svg :src="require('@/assets/img/external_link_icon.svg')"/>
                            </a>
                        </div>
                    </div>
                    <div class="btn_with_icon_wrpr" v-if="!hasSplitTests">
                        <v-button class="button btn_with_icon" :href="pageEditorUrl"
                                  :locked="!is('editor')"
                                  @click="redirectToPageBuilder">
                            <inline-svg :src="require('@/assets/img/pencil_edit_icon.svg')"/>
                            Edit page
                        </v-button>
                    </div>

	                <div class="ab-type-wrapper" v-if="hasSplitTests">
		                <v-select class="small"
				                      v-model="stepData.ab_type"
		                          :options="abTypes"
		                          @input="saveStepProps"
		                          label="label"
		                          :reduce="x=>x.id"
		                          :searchable="false"
		                          :clearable="false"
		                          append-to-body>
			                <template v-slot:option="o">
				                <div class="layout-column">
					                <b>{{ o.label }}</b>
					                <span>{{ o.desc }}</span>
				                </div>
			                </template>
		                </v-select>
		                <v-spinner v-if="savingProp" />
	                </div>
                </div>
            </div>
        </div>

		    <!-- only render pages separately if there are more than 1.		    -->
		    <step-page-entry v-if="hasSplitTests" v-for="page in stepData.pages" :step="stepData" :page="page" />

		    <div class="ab-page new" >
			    <div class="ab-linkage">
			    </div>
			    <v-button class="" slim v-tippy="{theme:'small-black'}" content="Create a new A/B test variation from a template"
			              :icon="require('@/assets/img/ab-testing.svg')"
			              label="New A/B test"
			              flat @click="createABVariantOpen=true" :locked="!is('editor')">
			    </v-button>
		    </div>
		    <create-a-b-variant-popup :source-page="stepData.pages[0]" :step="stepData" v-if="createABVariantOpen" @close="createABVariantOpen=false" />
	    </div>

        <!-- STEP CAN HAVE PRODUCTS -->
        <div class="panel funnels-panel products_panel" v-if="getSingleStepStore && getSingleStepStore && canHaveProducts(getSingleStepStore['type'])">
            <div class="layout-row flex">
                <h2 class="flex layout-row">Products
                    <Tooltip side='right'> Products in your funnel step</Tooltip>
                </h2>
                <v-button @click="createProductOpen=true" label="Add a new product" :locked="!is('editor')"/>
            </div>

          <!-- Orderbump -->
          <div class="panel-body panel-body_2 ordered-body entries-table" v-if="getObProducts.length">
            <!--               TODO: <ProductEntry v-for="(item, index) in getObProducts" :key="item.id" :product="item"></ProductEntry>-->
            <div class="entry panel-item" v-for="(item, index) in getObProducts" :key="item.id" >
              <router-link class="list-item-link cell" :to="{ path: `/wfunnel/${$route.params.id}/steps/${$route.params.step}/product/${item.id}`}">
                <div class="products_panel_first_cell cell">
                  <div class="products_panel_square_label">
                    <img :src="require('@/assets/img/ob_label.svg')" alt="">
                  </div>
                </div>
                <div class="panel-item-cell cell">
                  <div class="product_panel_link">{{item.name}}</div>
                  <span class="result-tag">
                      {{item.is_subscription ? 'Subscription' : 'One-time'}}
                  </span>
                </div>
                <div class="panel-item-cell product-price-cell cell" v-if="item.is_subscription">
                  <h3 class="price">{{formatPrice(item.billing_amount)}}</h3>
                  <span class="products_panel_weeks">
                      {{item.billing_cycle}}
                      {{ getCycleType(item.cycle_type) }}
                  </span>
                </div>
                <div class="panel-item-cell product-price-cell cell" v-else>
                  <h3 class="price">{{formatPrice(item.price)}}</h3>
                </div>
              </router-link>
              <div class="panel_item_btn_wrpr cell">
                <a @click.prevent="showCloneProductPopup(item)" class="panel_item_btn copy_btn"
                   :class="{'disabled':!is('editor')}" v-tippy="{theme:'small-black'}" content="Duplicate product">
                  <inline-svg :src="require('@/assets/img/copy_icon.svg')"/>
                </a>
                <a @click.prevent="showProductDeletePopup(item.id)" class="panel_item_btn delete_btn"
                   :class="{'disabled':!is('editor')}" v-tippy="{theme:'small-black'}" content="Delete product">
                  <inline-svg :src="require('@/assets/img/delete_icon.svg')"/>
                </a>
              </div>
            </div>
          </div>
          <!-- Other products -->
            <div class="panel-body panel-body_2 ordered-body entries-table" v-if="getProductsStore.length">
                <Container @drop="onDrop" lock-axis="y">
                    <Draggable v-for="(item, index) in getOtherProducts" :key="item.id" class="product-result-item">
                        <div class="panel-item entry" :data-order="item.order_index">
                            <router-link class="list-item-link" :to="{ path: `/wfunnel/${$route.params.id}/steps/${$route.params.step}/product/${item.id}`}">
                                <div class="products_panel_first_cell">
                                    <div class="number">#{{index + 1}}</div>
                                </div>
                                <div class="panel-item-cell">
                                    <div class="product_panel_link">
                                        {{item.name}}
                                    </div>
                                    <span class="result-tag">
                                        {{item.is_subscription ? 'Subscription' : 'One-time'}}
                                    </span>
                                </div>
                                <div class="panel-item-cell product-price-cell" v-if="item.is_subscription">
                                    <h3 class="price">{{ formatPrice(item.billing_amount) }}</h3>
                                    <span class="products_panel_weeks">
                                        {{item.billing_cycle}}
                                        {{ getCycleType(item.cycle_type) }}
                                    </span>
                                </div>
                                <div class="panel-item-cell product-price-cell" v-else>
                                    <h3 class="price">{{formatPrice(item.price)}}</h3>
                                </div>
                            </router-link >
                            <div class="panel_item_btn_wrpr">
                                <a @click.prevent="showCloneProductPopup(item)" class="panel_item_btn copy_btn"
                                   :class="{'disabled':!is('editor')}" v-tippy="{theme:'small-black'}" content="Duplicate product">
                                    <inline-svg :src="require('@/assets/img/copy_icon.svg')"/>
                                </a>
                                <a @click.prevent="showProductDeletePopup(item.id)" class="panel_item_btn delete_btn"
                                   :class="{'disabled':!is('editor')}" v-tippy="{theme:'small-black'}" content="Delete product">
                                    <inline-svg :src="require('@/assets/img/delete_icon.svg')"/>
                                </a>
                            </div>
                        </div>
                    </Draggable>
                </Container>
            </div>

            <div class="panel-body panel-body_2 empty-panel" v-else>
                <p>No products have been added yet</p>
            </div>

        </div>
	    <div class="panel funnels-panel products_panel" v-else-if="getSingleStepStore.cloning_products">
		    <div class="panel-head">
			    <h2>Products
				    <Tooltip side='right'>
					    Products in your funnel step
				    </Tooltip>
			    </h2>
			    <a class="btn disabled">Add a new product</a>
		    </div>

		    <div class="panel-body panel-body_2 empty-panel">
			    <div class="alert_box orange">
				    <inline-svg class="icon" :src="require('@/assets/img/alert_icon_yellow.svg')" />
				    <span>
					    Products cloning is in progress, this should take few more seconds.<br>
					    Refresh your page in a few seconds.
				    </span>
			    </div>
		    </div>
	    </div>
        <!-- STEP CAN'T HAVE PRODUCTS -->
        <div class="panel funnels-panel products_panel" v-else>
            <div class="panel-head">
                <h2>Products
                    <Tooltip side='right'>
                        Products in your funnel step
                    </Tooltip>
                </h2>
                <a class="btn disabled">Add a new product</a>
            </div>

            <div class="panel-body panel-body_2 empty-panel">
                <p>This step cannot have products, only <b>Order forms</b>, <b>Upsells</b> and <b>Downsells</b> may have products.</p>
            </div>
        </div>

        <!-- POPUPS -->
        <div class="popup_wrpr delete_popup_wrpr add_new_funnel_popup" :class="{active: getProductDeletePopup}">
            <ProductDeletePopup :productId="productId" v-if="getProductDeletePopup"
                                :is-fplus="true" :funnel-id="funnelId" :step-id="stepId" />
        </div>

        <div class="popup_wrpr add_new_funnel_popup" :class="{active: getCloneProductPopup}">
            <CloneProductPopup v-if="getCloneProductPopup" :product="productClone"
                               :step-id="stepId" :funnel-id="funnelId" :is-fplus="true"/>
        </div>
    </div>

		<CreateWProductPopup v-if="createProductOpen" :productsLength="getObProducts.length + otherProds.length"
		                     @close="createProductOpen=false" @done="createProductOpen=false"
		                     :step-id="stepId" :funnel-id="funnelId"  />

		<!-- PRODUCT DETAILS Only -->
		<router-view :products="getOtherProducts" :funnelStep="step"/>

		<popup-backdrop v-if="stepSettingsOpen" @close="stepSettingsOpen=false">
			<step-settings :funnel-id="funnelId" :step-id="stepId"
			               @delete="onDelete"
			               @done="stepSettingsOpen=false;reload()" @close="stepSettingsOpen=false" />
		</popup-backdrop>

		<delete-step-popup v-if="deleteStepOpen" :funnel-id="funnelId" :step-id="stepId" :step="stepData"
		                   @done="deleteStepOpen=false" @close="deleteStepOpen=false" />

	</div>
</template>

<script>
import MainSearch from "@/components/MainSearch.vue";
import ActivateAutomationPopup from "@/components/popups/automation/ActivateAutomationPopup.vue";
import ProductDeletePopup from "@/components/popups/delete/ProductDeletePopup.vue"
import CloneProductPopup from "@/components/popups/clone_product_popup"
import Loading from "@/components/Loading.vue"
import {mapGetters} from "vuex"
import API from "@/api"
import {formatPrice, getSymbol} from "@/helpers/currencies"
import { Container, Draggable } from 'vue-smooth-dnd'
import { applyDrag } from '@/helpers/sort'
import stepTypes from "@/helpers/stepTypes"
import Tooltip from "@/components/Tooltip.vue"
import ProductEntry from "@/components/base/product-entry";
import CreateWProductPopup from "@/views/funnels/funnel-plus/steps/create_wproduct_popup";
import VButton from "@/components/base/v-button";
import {types} from "@/helpers/stepTypes";
import VSpinner from "@/components/base/v-spinner";
import DeletePagePopup from "@/views/funnels/funnel-plus/steps/delete-page-popup";
import CreateABVariantPopup from "@/views/funnels/funnel-plus/steps/create-ab-variant-popup";
import InputField from "@/components/base/input-field";
import StepPageEntry from "@/views/funnels/funnel-plus/steps/step-page-entry";
import {is} from '@/helpers/roles';
import StepSettings from "@/views/funnels/funnel-plus/steps/step-settings";
import PopupBackdrop from "@/components/base/popup-backdrop";
import DeleteStepPopup from "@/views/funnels/funnel-plus/steps/delete-step-popup";
import QuickActionsBtn from "@/components/base/quick-actions-btn";
import PageRevisionsPopup from "@/views/funnels/funnel-plus/steps/page-revisions-popup";

export default {
    name: "FunnelSteps",
    components: {
	    PageRevisionsPopup,
	    QuickActionsBtn,
	    DeleteStepPopup,
	    PopupBackdrop,
	    StepSettings,
	    StepPageEntry,
	    InputField,
	    CreateABVariantPopup,
	    DeletePagePopup,
	    VSpinner,
	    VButton,
      CreateWProductPopup,
        ProductEntry,
        MainSearch,
        Loading,
        ActivateAutomationPopup,
        ProductDeletePopup,
        CloneProductPopup,
        Container, Draggable,
        Tooltip
    },
    mixins: [API],
    props: ['step'],
    data: function() {
        return {
	        revisionsPopupOpen:false,
	        stepSettingsOpen:false,
	        deleteStepOpen:false,
	        savingProp: false,
        	abTypes: [
		        {id:"geo", label:"Geo", desc:"Geo-targeting split." },
		        {id:"percent", label:"Random", desc:"Random A/B split-testing." }
	        ],
	        abCallback: false,
        	cloningMainPage: false,
	        createABVariantOpen: false,
	        isDeletePageOpen: false,
            createProductOpen: false,
            show: false,
            error: false,
            errorMessage: '',
            currentAutomation: false,
            isDragging: false,
            showEdit: false,
            loading: true,
            imageLoading: true,
            oldList: [],
            funnel: {},
		        stepData: {
	            thumbnail_hash: '',
            },
            products: [],
            otherProds: [],
            currentProduct: {},
            resultItems: stepTypes,
            productsTooltip: 'Lorem ipsum',
            productId: this.$route.params.productId,
            productClone: {},
            userData: {
                "type": "users",
                "id": "",
                "attributes": {}
            }
        };
    },
    computed: {
	    pageEditorUrl() {
		    let pageId = 0;
				let funnelId = this.$route.params.id;
				let stepId = this.$route.params.step
		    let userId = this.$store.state.userInfo.id;

		    if (this.stepData.pages.length > 0) {
			    pageId = this.stepData.pages[0].id;
		    }
		    // /wfunnel/:funnel/steps/:step/pages/:page/:token/:user
		    return `/page-editor/wfunnel/${funnelId}/steps/${stepId}/pages/${pageId}/${userId}`;
	    },
		    hasSplitTests() {
    		return this.stepData && this.stepData.pages && this.stepData.pages.length > 1;
	    },
	    currency() {
		    if (this.getFunnelStore && (this.getFunnelStore ? this.getFunnelStore.currency_code : "") !== "") {
			    return this.getFunnelStore.currency_code
		    }
		    return "USD"
	    },
        ...mapGetters([
            "getProductSettingsPopup",
            "getAutomationPopup",
            "getFunnelSettingPopup",
            "getActivateAutomationPopup",
            "getAddNewStepPopup",
            "getProductDeletePopup",
            "getStepDataStore",
            "getSingleStepStore",
            "getProductsStore",
            "getFunnelStore",
            "getCloneProductPopup"
        ]),
        getObProducts() {
            if(this.getProductsStore.length) {
                return this.sortProducts(this.getProductsStore.filter(item => item.is_ob));
            } else return []
        },
        getOtherProducts() {
            if(this.getProductsStore.length) {
                return this.sortProducts(this.getProductsStore.filter(item => !item.is_ob));
            } else return []
        },
	    stepId(){
		    return parseInt(this.$route.params.step)
	    },
	    funnelId(){
		    return parseInt(this.$route.params.id)
	    }
    },
    watch: {
        step(val) {
            this.loading = true;
            this.stepData = { };
            this.init(this.funnelId, val);
        },
        getOtherProducts(val) {
            this.otherProds = val;
        }
    },
    methods: {
			stepMenuClick(ev) {
				if (ev.action==='Revisions...') {
					this.revisionsPopupOpen = true;
				} else if (ev.action==='Delete step') {
					this.deleteStepOpen = true;
				}
			},
			formatPrice(price){
				return formatPrice(this.currency, price)
			},
			onDelete() {
				console.log("on delete")
				this.stepSettingsOpen=false;
				this.$router.push({path:`/wfunnel/${this.funnelId}`})
			},
	    is(role){
		    return is(role)
	    },
      canHaveProducts(id) {
	    	if (this.getSingleStepStore.cloning_products) return false;

        if(id) {
            switch (parseInt(id)) {
                case types.DOWNSELL:
                case types.UPSELL:
                case types.ORDER_FORM:
                    return true
                default:
                    return false
            }
        } else return false
      },
        sortProducts(arr) {
            function compare(a, b) {
                if (a['order_index'] < b['order_index']) return -1;
                if (a['order_index'] > b['order_index']) return 1;
                return 0;
            }
            return arr.sort(compare);
        },
        async onDrop (dropResult) {
            if(dropResult.removedIndex !== dropResult.addedIndex) {
                this.otherProds = applyDrag(this.otherProds, dropResult);

                var first = this.otherProds[dropResult.removedIndex];
                var second = this.otherProds[dropResult.addedIndex];

                var firstOrder = first['order_index'];
                var secondOrder = second['order_index'];

                first['order_index'] = secondOrder;
                second['order_index'] = firstOrder;

                this.otherProds.forEach(async (item, index) => {
                    item['order_index'] = index + 1;
                    var update = await this.api.wsteps.patchProduct(this.funnelId, this.step, item);
                })

                // var resFirst = await this.api.wsteps.patchProduct(this.$route.params.id, this.step, first);
                // var resSecond = await this.api.wsteps.patchProduct(this.$route.params.id, this.step, second);

                // this.$store.dispatch('EDIT_PRODUCT', resFirst.data);
                // this.$store.dispatch('EDIT_PRODUCT', resSecond.data);
            }
        },
        getCycleType(type) {
            var string = '';
            switch (type) {
                case 1:
                    string = ' day(s)';
                    break;
                case 2:
                    string = ' week(s)';
                    break;
                case 3:
                    string = ' month(s)';
                    break;
                case 4:
                    string = ' year(s)';
                    break;
            }
            return string
        },
        showAddNewStepPopup() {
            this.$store.commit("showAddNewStepPopup");
        },
        showProductDeletePopup(thisProductId) {
            this.productId = thisProductId;
            this.$store.commit("showProductDeletePopup");
        },
        showCloneProductPopup(item) {
            this.productClone = item;
            this.$store.commit("showCloneProductPopup");
        },
        copyToClipboard(queryElem) {
            let elemToCopy = document.querySelector(queryElem);
            elemToCopy.setAttribute('type', 'text');
            elemToCopy.select();

            try {
                var successful = document.execCommand('copy');

            } catch (err) {
                alert('Oops, unable to copy');
            }

            elemToCopy.setAttribute('type', 'hidden')
            window.getSelection().removeAllRanges()
        },
        redirectToPageBuilder(){
            let pageId = 0;

            if(this.stepData.pages.length > 0) {
                pageId = this.stepData.pages[0].id;
            }

            // /wfunnel/:funnel/steps/:step/pages/:page/:token/:user
            this.$router.push({path:
                '/page-editor/wfunnel/'+
                this.$route.params.id+'/steps/'+
                this.$route.params.step+'/pages/'+
                pageId +'/'+
                this.$store.state.userInfo.id
            });
        },
	    async clonePage(pageId) {
		    try {
			    this.cloningMainPage = true
			    let {id, step} = this.$route.params

			    let result = await this.api.wsteps.clonePage(parseInt(id), parseInt(step), parseInt(pageId));
			    if (!result.error) {
			    	this.stepData.pages.push(result);
			    }
		    } catch (e) {
			    this.$warn(e);
		    } finally {
			    this.cloningMainPage = false
		    }
	    },
	    async reload() {
				await this.init(this.funnelId, this.stepId)
	    },
        async init(id, step) {
      	try {
		      this.loading = true;
		      this.imageLoading = true;
		      let res = (this.getSingleStepStore && parseInt(this.getSingleStepStore.funnel_id) === parseInt(id) && parseInt(this.getSingleStepStore.id) === parseInt(step)) ? this.getSingleStepStore : await this.api.wsteps.get(id, step);

		      this.$store.dispatch('setSingleStepStore', res);

		      let check = await this.canHaveProducts(res.type);

		      if (check) {
			      let prodRes = res.products;
			      this.$store.dispatch('setProductsStore', prodRes);
		      }
		      this.stepData = res;
					if (!this.stepData.ab_type)
						this.stepData.ab_type = 'percent'
	      } catch (e) {
		      this.$notify({
			      type:"warn",
			      group: "main",
			      title: "Something went wrong... Please try again later",
		      });
		      console.error("error", e);
	      } finally {
		      this.loading = false;
		      this.show = true;
	      }
      },
	    async saveStepProps() {
		    try {
			    this.savingProp = true
			    let result = await this.api.wsteps.saveStepProps(this.stepData.funnel_id, this.stepData.id, {
				    // name: this.stepData.name,
				    ab_type: this.stepData.ab_type,
			    });
			    if (result.error) throw result;
			    // this.saved = true;
		    } catch (e) {
			    this.$warn(e);
		    } finally {
			    this.savingProp = false
		    }
	    },
    },
    created() {
        let {id, step} = this.$route.params;
        this.init(id, step);
    }
}
</script>
<style lang="scss" scoped>
.cloning-products {
	position: absolute;
	background: rgba(245, 245, 245, 0.98);
	border: 1px solid silver;
	padding: 10px;
}
</style>
<style lang="scss">
    .funnel_steps_top .settings_btn {
        position: absolute;
        right: 0;
        top: 15px;
	    padding: 10px 14px;
    }

    .funnel_steps_top .settings_btn:hover svg path {
        fill: #4368E0;
    }
    .product-result-item {
        cursor: pointer;
        &  a.list-item-link {
            cursor: pointer;
        }
    }
.fplus-step-details {
	.ab-type-wrapper {
		position: absolute;
		left: 30px;
		bottom: -12px;
		height: 24px;
		width: 82px;
		.v-select {
			font-size: 12px;
		}
		.vs__dropdown-toggle {
			height: 24px;
			background: white;
			border-radius: 15px;
			border: 1px solid #E4E6F1;; // border causes unwanted shift.
			.vs__selected {
				justify-content: center;
			}
			.vs__selected-options {
				padding: 0 2px;
			}
			.vs__search, .vs__search:focus {
				margin: 0 !important;
			}
		}
	}
	.ab-page {
		&.new {
			left: 1px;
			border: none;
			.button {
				display: flex;
				flex-direction: row;
				border: 1px solid $light-grey;
				color: #40454d;
				svg {
					margin-right: 10px;
					path {
						fill: #40454d;
					}
				}
				&:hover {
					color: $blue;
					svg path {
						fill: $blue;
					}
				}
			}
		}
	}
	.ab-page {
		display: flex;
		flex-direction: row;
		align-items: center;
		border: 1px solid $light-grey;
		margin-bottom: 10px;
		margin-left: 170px;
		border-radius: 8px;
		position: relative;

		.ab-linkage {
			position: absolute;
			left: -100px;
			border-left: 1px solid $light-grey;
			border-bottom: 1px solid $light-grey;
			top: 0;
			height: 50%;
			width: 100px;
			border-radius: 0 0 0 10px;

			&:before {
				height: 60px;
				width: 1px;
				background: $light-grey;
				top: -50px;
				content: "";
				position: absolute;
				left: -1px;
				z-index: -1;
			}

		}
		.img {
			border: 1px solid #E4E6F1;
			border-radius: 5px;
			overflow: hidden;
			width: 40px;
			display: flex;
			align-items: flex-start;
			height: 40px;
			margin: 4px;
			min-width: 40px;
			img {
				object-fit: cover;
				width: 100%;
			}
		}
		.name {
			flex: 1;
			margin-left: 5px;
			//h3 {
			//	margin: 2px 0;
			font-weight: 500;
			font-size: 14px;
			line-height: 150%;
			letter-spacing: 0.02em;
			color: #252A32;
			//}
		}
	}
}
</style>
<style lang="scss" scoped>
.__actions-btns {
	display: flex;
	flex-direction: row;
	align-items: center;
	gap: 10px;
	position: absolute;
	right: 40px;
	top: 30px;
	padding: 10px;
	.__sep {
		height: 24px;
		width: 1px;
		background: $grey;
	}
}
.funnel_tag {
	font-size: 12px;
	line-height: 14px;
	padding: 2px 8px;
	.icon {
		width: 15px;
		height: 15px;
		margin-right: 6px;
	}
}

.funnel_steps_top {
	margin-top: 60px;
	margin-bottom: 15px;
	border: 1px solid $light-grey;
	border-radius: 8px;
	padding: 10px;
	background: white;
	.left_img_wrpr {
		border: 1px solid #E4E6F1;
		border-radius: 5px;
		overflow: hidden;
		width: 140px;
		margin-right: 30px;
		display: flex;
		align-items: flex-start;
		height: 150px;
	}
	.right h3 {
		margin: 2px 0;
		font-weight: 500;
		font-size: 24px;
		line-height: 150%;
		letter-spacing: 0.02em;
		color: #252A32;
	}
	&.first-page {
		&.has-split-test {
			// shrink for split tests.
			.left_img_wrpr {
				height: 105px;
			}
		}
		.btns {
			position: absolute;
			top: 10px;
			right: 0;
			flex: none;
			display: flex;
			flex-direction: row;
			align-items: center;
			.button {
				margin-right: 20px;
				padding: 10px;
				color: #C5C7D2;
				svg {
					margin: auto;
				}
				svg, path {
					color: #C5C7D2;
				}
			}
		}
	}
}

.funnel_steps_url_item {
	margin-bottom: 5px;
	.item_title {
		font-weight: 500;
		font-size: 14px;
		line-height: 150%;
		letter-spacing: 0.02em;
		color: #636A7B;
		margin-bottom: 0;
	}
}
.products_panel {
	margin-top: 50px;
}
</style>
